<template>
  <div class="faq-container" v-if="faqs.length > 0">
    <div v-if="showTitle" class="title">
      {{ intl[$store.state.lang]["related-questions"] }}
    </div>
    <baseLoader v-if="faqLoader"></baseLoader>

    <div v-else class="accordion" id="faqContainer">
      <div
        class="accordion-item"
        v-for="(faq, index) in joomlaFaqs"
        :key="faq.id"
      >
        <h2 class="accordion-header" :id="'heading-' + faq.id">
          <h4
            :class="['accordion-button', faq?.isOpen ? '' : 'collapsed']"
            type="button"
            @click="toggleAccordion(index)"
            :data-bs-target="'#collapse-' + index"
            :aria-expanded="faq?.isOpen ? 'true' : 'false'"
            :aria-controls="'collapse-' + index"
          >
            <span>{{ faq.id + ") " + faq.title }}</span>
          </h4>
        </h2>
        <div
          :id="'collapse-' + index"
          :class="['accordion-collapse', 'collapse', faq.isOpen ? 'show' : '']"
          :aria-labelledby="'heading-' + faq.id"
          data-bs-parent="#faqContainer"
        >
          <div v-html="faq.introtext" :class="'accordion-body'"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import intl from "./intl/intl";
import axios from "axios";
import BaseLoader from "../loaders/baseLoader/BaseLoader.vue";
import { apiUrls } from "../../api/apiUrls";
export default {
  name: "faq",
  components: {
    baseLoader: BaseLoader,
  },
  props: {
    setPaginaLoaderCallback: {
      type: Function,
      default: (value) => {
        return
      },
    },
    answerId: {
      type: Number,
      default: null,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },

    renderComponent: {
      type: Boolean,
      default: true,
    },
    onLoadDataEnded: {
      type: Function,
      default: (response, faqs) => {
        console.log("Caricamento dati finito");
      },
    },
    onLoadDataStarted: {
      type: Function,
      default: () => {
        console.log("Caricamento dati iniziato");
      },
    },
  },

  created() {
    if (this.answerId) {
      this.getJoomlaFaqs();
    }
  },

  data: function () {
    return {
      intl: intl,
      test: true,
      faqLoader: false,
      faqs: [],
      joomlaFaqs: [],
    };
  },
  methods: {
    toggleAccordion(index) {
      this.joomlaFaqs.map((item, i) => {
        if (i === index) {
          item.isOpen = !item.isOpen;
        } else {
          item.isOpen = false;
        }
      });
    },
    async getJoomlaFaqs() {
      await this.getAnswerDetail();
      if (this.faqs.length > 0) {
        let queryIds = this.faqs
          .map(function (faq) {
            return "ids[]=" + encodeURIComponent(faq.id_faq);
          })
          .join("&");
        axios
          .get(apiUrls["joomla_faqs_by_faq_ids"] + "?" + queryIds)
          .then((response) => {
            if (response?.data) {
              this.joomlaFaqs = response.data;
              this.joomlaFaqs.map((joomlaFaq,i) => {
                if(i === 0){
                  joomlaFaq.isOpen = true;
                }else{
                  joomlaFaq.isOpen = false
                }
              })
            }
            this.onLoadDataEnded(response, this.joomlaFaqs);
            this.faqLoader = false;
          })
          .catch((error) => {
            this.joomlaFaqs = [];
            this.onLoadDataEnded(error, this.joomlaFaqs);
            this.faqLoader = false;
          });
      } else {
        this.onLoadDataEnded(null, []);
        this.faqLoader = false;
      }
    },
    async getAnswerDetail() {
      if (this.answerId) {
        this.faqLoader = true;
        this.onLoadDataStarted();
        await axios
          .get(apiUrls["answer_detail"] + this.answerId)
          .then((response) => {
            if (
              response.data &&
              response.data.answerFaq &&
              response.data.answerFaq.length > 0
            ) {
              response.data.answerFaq.map((answerFaq, i) => {
                this.faqs.push(answerFaq);
              });
            }
          })

          .catch((error) => {
            this.onLoadDataEnded(error, this.faqs);

            this.faqLoader = false;
          });
      }
    },
  },
  watch: {
    faqLoader: {
      handler: function (newValue, oldValue) {
        if (oldValue !== newValue) {
          this.setPaginaLoaderCallback({ faqLoader: newValue });
        }
      },
      deep: true,
    },
    answerId: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getJoomlaFaqs();
      }
    },
  },
  computed: {},
};
</script>
